import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import media from '../MediaQueries.js';
import styled from 'styled-components';
import axios from 'axios';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';

export default class FAQ extends Component {

  constructor(props) {
    super(props);

    this.state = {
      faqList: [],
      faqOpenArray: []
    };
  }

  componentDidMount() {
    this.setFaqList();
  }

  setFaqList = () => {
    axios.get('https://s3.amazonaws.com/primitivescandlesstorage/faq/FAQList.json')
      .then(response => {
        this.setState({
          faqList: response.data
        }, () => { this.createFaqOpenArray(); } );
        
      })
      .catch(error => {
        console.log('Error fetching and parsing data', error);
      });
  }

  createFaqOpenArray = () => {
    let faqOpenArray = [];
    for(let i=0; i<this.state.faqList.length; i++) {
        faqOpenArray.push(false);
    }

    this.setState({ faqOpenArray });
  }

  faqCollapseToggle = (index) => {

    // If the element is selected and clicked, close it.
    let currentlySelectedIndex;
    let faqOpenArray = this.state.faqOpenArray;

    for(let i=0; i<faqOpenArray.length; i++) 
    {
      if(faqOpenArray[i] == true)
      {
        currentlySelectedIndex = i;
      }
    }
    if(currentlySelectedIndex == index) {
      faqOpenArray[index] = false;
    }
    else 
    // If a different element was clicked, open the new one & close all others.
    {
      for(var i=0; i<faqOpenArray.length; i++) 
      {
        faqOpenArray[i] = false;
      }
      faqOpenArray[index] = true;
    }

    this.setState({ faqOpenArray });
  }

  render () {
    const FAQView = this.state.faqList.map((faq, index) => {
      return <ItemDropdownContainer containerOpen={this.state.faqOpenArray[index]} key={index} 
        onClick={() => this.faqCollapseToggle(index)}>
        <Dropdown toggle={() => ''} >
          <DropdownToggle caret>
            {/*<h2 dangerouslySetInnerHTML={{__html: faq.q}}></h2>*/}
            <h2>{faq.q}</h2>
          </DropdownToggle>
        </Dropdown>
        <Collapse isOpen={this.state.faqOpenArray[index]}>
            <p>
              {faq.a} 
              {faq.id == 8 ? <Link style={{color: "#8A572A", fontWeight: "bold"}} to="/Contact">contact page!</Link> 
                : "" }
              {faq.id == 9 ? <a style={{color: "#8A572A", fontWeight: "bold"}} target="_blank" 
                href="https://www.google.com/maps/place/93+Germania+St,+Galeton,+PA+16922/@41.7319713,-77.6506319,17z/data=!3m1!4b1!4m5!3m4!1s0x89ce19f9457092e1:0xe0b43148ccbcf991!8m2!3d41.7319713!4d-77.6484432">(click here for directions.)</a> 
                : "" }
            </p>
        </Collapse>
      </ItemDropdownContainer>
    })

  	return (
      <Container_s>
        <Helmet>
          <title>Frequently Asked Questions - Primitives Candles</title>
        </Helmet>
        <Container_1000>

            <h2>Frequently Asked Questions</h2>
            <h3>Find answers to our most common questions</h3>
            <hr />
            {FAQView}
            <hr />
        </Container_1000>
      </Container_s>
  	);
  }
}

const Container_s = styled(Container)`
  padding: 0!important;
  padding-top: 10px!important;
`;

const Container_1000 = styled(Container)`
  max-width: 1000px;
  margin: 0 auto;
  padding: 0!important;

  h2,h3 {
    color: #76451F;
    font-size: 36px;
    font-weight: bold;
    text-align: center;
    margin: 10px 15px 10px 15px;
  }
  h3 {
    color: black;
    font-size: 15px;
    ${media.lg` font-size: 17px; `}
    ${media.xl` font-size: 19px; `}
    margin-bottom: 20px;

  }
  hr {
    border-top: 1.1px solid #8A572A;
  }
`;

const ItemDropdownContainer = styled(({ containerOpen, ...rest }) => <Container {...rest} />)`
  margin-bottom: 10px;
  text-align: left;
  background-color: ${a => a.containerOpen ? "#BCA368" : "#c9b483"};
  cursor: pointer;

  .dropdown {
    background-color: ${a => a.containerOpen ? "#BCA368" : "#c9b483"};
    height: 100px;
    line-height: 100px;

    button {
      width: 100%;
      padding: 0;
      font-family: 'Handlee';
      background: none;
      border: none;
      vertical-align: middle;
      word-break: break-all;
      white-space: normal;
      cursor: pointer;
      

      h2 {
        margin: 0;
        font-size: 20px;
        ${media.lg` font-size: 22px; `}
        text-align: left;
        
        color: #76451F;
        font-weight: bold;
      }

      ::after {
        float: right;
        margin-top: -9px;
          border-top-width: ${a => a.containerOpen ? 0 : ""};
          border-bottom: ${a => a.containerOpen ? "4.8px solid #000000" : ""};
      }

      :focus {
        box-shadow: none;
      }
    }
  }
  .collapse, .collapsing {
    background-color: ${a => a.containerOpen ? "#BCA368" : "#c9b483"};

    p {
      margin-bottom: 0px;
      font-size: 14px;
      ${media.lg` font-size: 16px; `}
      font-family: 'Raleway';
    }
  }
`;


// WEBPACK FOOTER //
// ./src/pages/FAQ.js